var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "psychological-teachers-use" },
    [
      _c(
        "div",
        {
          staticClass: "record-title",
          staticStyle: { "margin-bottom": "20px" },
        },
        [_vm._v("心理老师使用数据")]
      ),
      _c("CoachingCoreData", { attrs: { dataSource: _vm.coachingCoreData } }),
      _c(
        "div",
        { staticClass: "title-1", staticStyle: { margin: "20px 0 10px" } },
        [_vm._v(_vm._s(_vm.title))]
      ),
      _c("div", { staticClass: "flex-between" }, [
        _c("span", [
          _vm._v("\n      未采集到的学生共\n      "),
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "16px",
                "font-weight": "bold",
                color: "#fa3a25",
              },
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.faceCollectInfo.faceNotGatherCount) +
                  "\n      "
              ),
            ]
          ),
          _vm._v("\n      人\n    "),
        ]),
        _c(
          "span",
          {
            staticStyle: { color: "#2a82e4", cursor: "pointer" },
            on: { click: _vm.viewModal },
          },
          [
            _vm._v("\n      查看详情\n      "),
            _c("a-icon", { attrs: { type: "right" } }),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "tip", staticStyle: { margin: "12px 0 5px" } }, [
        _c("span", [
          _c("img", {
            staticStyle: {
              width: "14px",
              height: "14px",
              "margin-right": "5px",
            },
            attrs: {
              src: require("@/assets/imgs/school/monthRecord/warningMark.png"),
              alt: "",
            },
          }),
          _vm._v(
            "\n      本月未采集到学生共" +
              _vm._s(_vm.faceCollectInfo.faceNotGatherCount) +
              "人，其中有底图未采集的" +
              _vm._s(_vm.faceCollectInfo.haveFaceNotGather) +
              "人，无底图的" +
              _vm._s(_vm.faceCollectInfo.withOutFaceNotGather) +
              "人，请确认是否有请假、休学、外出、课间活动量少的情况，建议持续关注或更新底图。\n    "
          ),
        ]),
      ]),
      _c("TableList", {
        staticStyle: { width: "100%", "margin-top": "5px" },
        attrs: {
          columns: _vm.columns,
          tableData: _vm.dataSource,
          loading: _vm.loading,
          scroll: {},
        },
      }),
      _c("DetailModal", {
        ref: "detailModalRef",
        attrs: { title: _vm.title, columns: _vm.columns, url: _vm.url },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }